import * as React from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
} from 'react-admin';
import DatabaseItemTitle from './DatabaseItemTitle';

const DatabaseItemShow = props => (
    <Show title={<DatabaseItemTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="type" />
            <TextField source="hostname" />
            <TextField source="port" />
            <TextField source="username" />
            <TextField source="password" />
            <TextField source="version" />
            <TextField source="database_list" />
        </SimpleShowLayout>
    </Show>
);

export default DatabaseItemShow;